import React, { Component } from "react"
import { Button, Chip, FormHelperText, Grid, Input, Typography } from "@material-ui/core"
import { Link } from "react-router-dom"
import SectionHeader from "../../../components/SectionHeader"
import rebase, { auth } from "../../../config/rebase"
import { criteriaGradingRules, oralPresentationStartTime, dbPrefix, knowledgeAreaArray, days, minutesPerBanner, minutesPerOral } from "../../../Constants"
import Wrapper from "../../../components/Common/Wrapper"
import CustomCardItem from "../../../components/Cards/CustomCardItem"
import CustomAlert from "../../../components/CustomAlert"
import { getUsersByUID, isPaperGradesAvailable, isTableGenerationAvailable } from "../../../utils"
import SimpleTable from "../../../components/Table/SimpleTable"
import PaperTable from "../../../components/Table/PaperTable"
import moment from 'moment'
import Report from "../../../components/Paper/Report"
import { server } from "../../../server"

class Finals extends Component {

    state = {
        showTable: false,
        learnMoredialog: false,
        selectedArea: false,
        papers: {},
        allPapersArr: [],
        noReportArr: [],
        bestPapersArr: [],
        notBestPapersTitleArr: [],
        notAcceptedArr: [],
        filtered: [],
    }

    async componentDidMount() {
        console.log(server)
        try {
            const data = await rebase.fetch(dbPrefix + 'papers', {
                asArray: true,
            })
            // [{}]

            const papers = {}
            const acceptedArr = []
            const notAcceptedArr = []
            const noReportArr = []

            for (const paper of data) {
                if (!!paper.reports) {

                    // Verifica se há alguma avaliação não aceita
                    const isNotAccepted = Object.values(paper.reports).find(r => r.accepted === false)

                    // Seta final como 0 e falsa
                    if (isNotAccepted) {
                        paper.finalGrade = 0
                        paper.accepted = false
                        notAcceptedArr.push(paper)
                    } else {
                        // Se não faz a soma
                        // para cada avaliação
                        const reportsArray = Object.values(paper.reports)
                        let sum = 0
                        for (const report of reportsArray) {
                            for (const prop of criteriaGradingRules) {
                                // Se existir esta prop na avaliação
                                // soma
                                if (report[prop.name]) {
                                    sum += Number(report[prop.name])
                                }

                            }
                        }
                        paper.finalGrade = Number(sum / (criteriaGradingRules.length * reportsArray.length)).toFixed(2)
                        paper.accepted = true
                        acceptedArr.push(paper)

                    }
                } else {
                    noReportArr.push(paper)
                }
            }

            const allPapersArr = data.sort((a, b) => parseFloat(b.finalGrade) - parseFloat(a.finalGrade))
            const bestPapersArr = []

            for (const k of knowledgeAreaArray) {
                const filteredNOrdered = acceptedArr.filter(e => e.knowledgeArea === k.value)
                    .sort((a, b) => parseFloat(b.finalGrade) - parseFloat(a.finalGrade))

                papers[k.value] = filteredNOrdered

                if (filteredNOrdered.length) {
                    bestPapersArr.push(filteredNOrdered[0])
                }
            }

            this.setState({ papers, noReportArr, notAcceptedArr, allPapersArr, bestPapersArr })
        } catch (error) {
            console.log(error)
            this.setState({ error: 'Ocorreu um erro' })
        } finally {
            this.setState({ loaded: true })
        }

    }

    columns = [
        {
            name: "paperTitle",
            label: "Nome",
            options: {
                filter: false
            }
        },
        {
            name: "knowledgeArea",
            label: "Área de Conhecimento",
            options: {
                customBodyRender: (val) => {
                    const area = knowledgeAreaArray.find(k => val === k.value)
                    return <span>{area.title}</span>
                }
            }
        },
        {
            name: "grade",
            label: "Nota",
            options: {
                customBodyRender: (val) => {
                    return !isNaN(val) ? val : "-"
                }
            }
        },
        {
            name: "Visualizar",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (index) => {
                    return (
                        <Button
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            component={Link}
                            to={"/admin/ver-paper/" + this.state.papers[index].key}>
                            &#8594;
                        </Button>
                    )
                }
            }
        }

    ];

    handleClick(selectedArea) {
        if (selectedArea === this.state.selectedArea) {
            return
        }

        if (selectedArea === 'all') {
            return this.setState({ filtered: this.state.allPapersArr, selectedArea })
        }

        return this.setState({ filtered: this.state.papers[selectedArea], selectedArea })
    }

    async generateTable() {

        const notBestPapersTitleArr = this.state.allPapersArr
            .filter(paper => !this.state.bestPapersArr.includes(paper) && !this.state.notAcceptedArr.includes(paper))
            .sort((a, b) => a.paperTitle > b.paperTitle ? 1 : -1)

        let dia = 0
        let grupo = 0

        let diaLimit = days.length
        // suporte para qtd de grupos ===
        let grupoLimit = days[dia].length

        let end = moment(days[dia][grupo].end)
        let start = moment(days[dia][grupo].start)
        let arr = []

        for (let k = 0; k < notBestPapersTitleArr.length; k++) {

            if (start.isSameOrAfter(end)) {

                ++grupo
                if (grupo >= grupoLimit) {
                    ++dia
                    grupo = 0
                }

                if (dia >= diaLimit) {
                    break
                }

                start = moment(days[dia][grupo].start)
                end = moment(days[dia][grupo].end)
            }

            let o = moment(start)
            let s = o.valueOf()
            let e = o.add(minutesPerBanner, 'minutes').valueOf()

            arr.push([s, e])
            arr.push([s, e])

            start.add(minutesPerBanner, 'minutes')
        }

        for (let index = 0; index < notBestPapersTitleArr.length; index++) {
            const element = notBestPapersTitleArr[index];
            element.startingAt = arr[index][0]
            element.endingAt = arr[index][1]
            element.banner = true
        }

        const bestPapersArrOrdered = this.state.bestPapersArr
            .sort((a, b) => a.paperTitle > b.paperTitle ? 1 : -1)

        const oralMoment = moment(oralPresentationStartTime)
        try {
            this.setState({ loaded: false })
            for (let index = 0; index < bestPapersArrOrdered.length; index++) {
                const element = bestPapersArrOrdered[index];

                const a = await (await getUsersByUID(element.usersId)).map(e => e.uEmail)

                let o = moment(oralMoment)
                let s = o.valueOf()
                let e = o.add(minutesPerOral, 'minutes').valueOf()

                element.banner = false

                element.startingAt = s
                element.endingAt = e
                oralMoment.add(45, 'minutes')
                element.emails = a
            }

        } catch (error) {
            console.log(error)
            this.setState({ error: "Ocorreu um erro ao buscar os participants", loaded: true })
        }
        this.setState({ loaded: true, showTable: true, notBestPapersTitleArr, bestPapersArr: bestPapersArrOrdered })

    }

    async save() {
        try {
            this.setState({ loaded: false })

            // PEGAR TODOS OS PARTICIPANTES DE CADA TRABALHO NÃO ACEITO E MUDAR PARA PARTICIPANTES 
            for (const obj of this.state.notAcceptedArr) {
                for (const cpf of obj.usersId) {
                    rebase.update(dbPrefix + 'users/' + cpf, {
                        data: {
                            type: "1"
                        }
                    }).catch(error => {
                        console.log(error)
                        return this.setState({ error: "Ocorreu um erro ao atualizar autor para participante" })
                    })
                }
            }
            console.log('ok')
            const all = [...this.state.notAcceptedArr, ...this.state.bestPapersArr, ...this.state.notBestPapersTitleArr]

            // notAcceptedArr
            // console.log(all)
            for (const p of all) {

                let { finalGrade, accepted, endingAt, startingAt, banner } = p
                let data

                // console.log(p)
                if (!startingAt) {
                    if (banner !== undefined) {
                        data = { finalGrade, accepted, banner }
                    } else {
                        data = { finalGrade, accepted }
                    }
                } else {
                    if (banner !== undefined) {
                        data = { finalGrade, accepted, banner, endingAt, startingAt }
                    } else {
                        data = { finalGrade, accepted, endingAt, startingAt }
                    }
                }
                await rebase.update(dbPrefix + 'papers/' + p.key, {
                    data
                })
                console.log('Salvo para ' + p.paperTitle)
            }

            const users = await rebase.fetch(dbPrefix + 'users', {
                asArray: true,
                queries: {
                    orderByChild: 'accessCodes',
                    equalTo: null
                }
            })

            for (const u of users) {
                const pass = u.ucpf.split("").reverse().join("")

                await auth.createUserWithEmailAndPassword(u.uEmail, pass)
                // const res = await auth.createUserWithEmailAndPassword(u.uEmail, pass)
                // console.log(res)

                const data = {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        email: u.uEmail
                    })
                }
                // const res = await fetch(server + '/accountCreated', data)
                // const json = await res.json()
                // console.log(json)

                await fetch(server + '/accountCreated', data)
                console.log(`E-mail enviado para ${u.uEmail}`)
            }

            this.setState({ success: 'Notas atribuídas e e-mails enviados com sucesso' })
            alert("Ok. Deslogando...")
            window.location.href = "/logout"

        } catch (error) {
            console.log(error)
            this.setState({ error: "ocorreu um erro.." })
        } finally {
            this.setState({ loaded: true })
        }

    }
    render() {
        return (
            <Wrapper success={this.state.success} loaded={this.state.loaded} fatalError={this.state.error} currentPath={"/admin/papers"} adminTopbar>
                <SectionHeader
                    title="Finalização"
                    subtitle="Esta etapa consiste em gerar as notas finais, gerar cronogramas e comunicar os autores"
                />

                {
                    isPaperGradesAvailable() ?
                        this.state.showTable ?
                            <CustomCardItem>
                                <Typography>Apresentações Orais (Melhores trabalhos)</Typography>
                                <CustomAlert severity="info" message={`Os melhores trabalhos serão apresentados no segundo dia via Youtube, ${minutesPerOral}min cada`} />
                                {
                                    this.state.bestPapersArr.length && (
                                        <>
                                            <PaperTable
                                                papers={this.state.bestPapersArr}
                                            />
                                        </>
                                    )
                                }
                                <Typography>Apresentações em Banner</Typography>
                                <CustomAlert severity="info" message={`Apresentações em Banner, ${minutesPerBanner}min cada`} />

                                {
                                    this.state.notBestPapersTitleArr.length && (
                                        <PaperTable
                                            papers={this.state.notBestPapersTitleArr}
                                        />
                                    )
                                }
                                {
                                    isTableGenerationAvailable() &&
                                    <Button
                                        color="primary"
                                        fullWidth
                                        onClick={this.save.bind(this)}>
                                        Salvar
                                </Button>
                                }
                            </CustomCardItem>
                            :
                            <Button
                                variant="outlined"
                                color="primary"
                                fullWidth
                                onClick={this.generateTable.bind(this)}>
                                Gerar Tabela para Cronograma
                        </Button>
                        :
                        <CustomCardItem>
                            <Typography>Geração de Cronograma expirado ou completo</Typography>
                        </CustomCardItem>
                }
                <Grid
                    container
                    justify="space-around" alignContent="center" alignItems="center">
                    <Grid item xs={10}>
                        <Typography variant="h3">Quantitativo</Typography>
                        <SimpleTable
                            cols={['Sem Avaliação', 'Total de Avaliados', 'Total de Rejeitados', 'Nesta Categoria']}
                            rows={[this.state.noReportArr.length, this.state.allPapersArr.length, this.state.notAcceptedArr.length, this.state.filtered.length]}
                        />
                        <br />
                        {
                            this.state.notAcceptedArr.length ? (
                                <>
                                    <Typography variant="h4" color="error">Rejeitados</Typography>
                                    <PaperTable
                                        papers={this.state.notAcceptedArr}
                                    />
                                </>
                            )
                                :
                                null
                        }
                    </Grid>
                </Grid>
                {
                    knowledgeAreaArray.map(k => (
                        <Chip key={k.value} clickable={k.value !== this.state.selectedArea} variant={k.value === this.state.selectedArea ? 'outlined' : 'default'} label={k.value} onClick={() => this.handleClick.bind(this)(k.value)} />
                    ))
                }
                <Chip key={'all'} clickable={'all' !== this.state.selectedArea} variant={'all' === this.state.selectedArea ? 'outlined' : 'default'} label="Todos" onClick={() => this.handleClick.bind(this)('all')} />

                <CustomCardItem>
                    {this.state.selectedArea ? (
                        <Typography>Exibindo em Ordem decrescente</Typography>
                    )
                        :
                        <Typography>Por favor, selecione uma opção</Typography>
                    }
                </CustomCardItem>
                {
                    this.state.filtered.map((p) => (
                        <CustomCardItem key={p.paperTitle}>
                            <Typography>
                                Título: {p.paperTitle}
                            </Typography>
                            <Typography>
                                Avaliações:
                            </Typography>
                            {
                                Object.values(p.reports).map((r, i) => (
                                    <Report key={i + 'k'} report={r} showAccessCodes />
                                ))
                            }
                            <Input
                                type="number"
                                fullWidth
                                name={'finalGrade'}
                                disabled
                                value={p.finalGrade}
                                required
                                aria-describedby={"finalGrade-helper"}
                                inputProps={{
                                    max: 10,
                                    maxLength: 4,
                                    min: 0
                                }}
                            />
                            <FormHelperText id={"finalGrade-helper"}>Média final</FormHelperText>
                            {
                                p.accepted ?
                                    <CustomAlert severity='success' message="Trabalho aceito" />
                                    :
                                    <CustomAlert message="Trabalho não aceito" />
                            }
                        </CustomCardItem>
                    ))
                }
            </Wrapper >
        )
    }
}

export default Finals